import EditIcon from "@mui/icons-material/EditOutlined";
import { IconButton, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { InboxChannelInfo } from "../../../../../api/types/workflowTypes";
import useClientContext from "../../../../../context/useClientContext";
import { pageRoutes } from "../../../../../routes";
import AgentInboxChannelTypeAvatar from "../../../agentic-workflows/agent-inboxes/AgentInboxChannelTypeAvatar";
import WorkflowTemplateDetailsContext from "../WorkflowTemplateDetailsContext";

interface Props {
  inboxChannels: InboxChannelInfo[];
}

const WorkflowChannelsCardContent = ({ inboxChannels }: Props) => {
  const { clientCode, hasPermissions } = useClientContext();

  const { hasEditPermissions } = useDefinedContext(WorkflowTemplateDetailsContext);

  const navigate = useNavigate();

  if (inboxChannels.length === 0) {
    return <Typography color="textSecondary">No inbox channels configured yet.</Typography>;
  }

  const showEditButton = hasEditPermissions && hasPermissions(["ManageInboxes"]);

  const handleEditChannel = (channel: InboxChannelInfo) => {
    navigate(
      `/${clientCode}/${pageRoutes.integration}/${pageRoutes.agenticWorkflows}/${pageRoutes.agentInboxes}/${channel.inboxId}?channel=${channel.channelId}`
    );
  };

  return (
    <Stack spacing={0.5}>
      {inboxChannels.map((channel) => (
        <Paper key={channel.channelId} variant="outlined">
          <Stack spacing={0.5} sx={{ p: 1 }}>
            <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <AgentInboxChannelTypeAvatar channelType={channel.type} size={20} color="secondary" />
              <Typography variant="subtitle2" noWrap>
                {channel.name}
              </Typography>
              <HorizontalFill />
              {showEditButton && (
                <IconButton onClick={() => handleEditChannel(channel)} sx={{ pr: 0 }}>
                  <EditIcon />
                </IconButton>
              )}
            </Stack>

            {channel.address && (
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <Typography variant="caption" noWrap color="textSecondary">
                  {channel.address}
                </Typography>
                <CopyToBufferButton textToCopy={channel.address} />
              </Stack>
            )}
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};

export default WorkflowChannelsCardContent;
